import styled from 'styled-components';

import { videoBaseStyles } from '../../common/Common.styles';

export const StyledSectionVideo = styled.video`
    ${videoBaseStyles}
`;
